export default __webpack_public_path__ + "static/media/img44.7779a331.jpg";